import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NgxPermissionsModule } from "ngx-permissions";
import {
    ReactiveFormsModule,
    FormsModule
} from "@angular/forms";
import { DetalleCotizacionPaginaRoutingModule } from "./detalle-cotizacion-pagina-routing.module";
import { DetalleCotizacionPaginaComponent } from "./detalle-cotizacion-pagina.component";
import { BotonToggleModule } from "../../../../components/boton/boton-toggle.module";
import { PipesModule } from "../../../../pipes/pipes.module";
import { MaterialModule } from "../../../../components/material/material.module";
import { VolverModule } from "../../../../components/volver/volver.module";
import { CotizacionModule } from "../../../../forms/cotizaciones/cotizacion.module";
import { IncidenciaModule } from "../../../../forms/incidencias/incidencia.module";
import { ItemModule } from "../../../../forms/cotizaciones/items/item.module";
import { TareaModule } from "../../../../forms/tareas/tarea.module";
import { ArchivoCotizacionModule } from "../../../../forms/cotizaciones/archivos-cotizacion/archivo-cotizacion.module";
import { ActividadesModule } from "../../../../components/actividades/actividades.module";
import { ActividadesService } from "../../../../providers/actividades.service";

@NgModule({
    imports: [
        CommonModule,
        NgxPermissionsModule.forChild(),
        ReactiveFormsModule,
        FormsModule,
        DetalleCotizacionPaginaRoutingModule,
        BotonToggleModule,
        PipesModule,
        MaterialModule,
        VolverModule,
        CotizacionModule,
        IncidenciaModule,
        ItemModule,
        TareaModule,
        ArchivoCotizacionModule,
        ActividadesModule,
    ],
    declarations: [
        DetalleCotizacionPaginaComponent
    ],
    providers: [
        ActividadesService
    ],
    entryComponents: [

    ]
})
export class DetalleCotizacionPaginaModule { }